let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eHa2y")).then(() => parcelRequire('fblbh'));